










import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: { }
})
export default class Breadcrumb extends Vue {
  get items () {
    return this.$route.meta?.breadcrumb || []
  }

  to (item: any, i: number) {
    if (i === this.items.length - 1 || !item.active) return undefined
    return item.path
  }

  normalizeTitle (title = '') {
    const params = Object.assign({}, this.$route.query || {}, this.$route.params || {})
    const regex = /-\{(\w+)\}/g
    return title.replace(regex, (_, c) => {
      // return params[c] || ''
      return ''
    })
  }
}
